import React, {Fragment} from 'react';
import {Col, Row} from 'react-bootstrap';

export const SurveyFormComposedInput = props => {
    const { children, Validation } = props;
    
    if (children && children.length) {
        return <Fragment>
            { children.map((component, i) =>
                <Row key={i} className="bottom10">
                    <Col xs={12}>
                        {component}
                    </Col>
                </Row>
            )}
            {
                Validation != null ?
                    <p className="sb-survey-validation-error">{Validation}</p> :
                    null
            }
        </Fragment>;
    }
    
    return null;
};


